import React from "react";

const TermsPage = () => {
  return (
    <div className="container">
      <div className="main">
        <div className="title">Terms and Conditions (&quot;Terms&quot;)</div>
        Last updated: 10/01/2023
        <br />
        Please read these Terms and Conditions (&quot;Terms&quot;, &quot;Terms
        and Conditions&quot;) carefully before using the Voicify.ai website (the
        &quot;Service&quot;) operated by Voicify (&quot;us&quot;,
        &quot;we&quot;, or &quot;our&quot;). Your access to and use of the
        Service is conditioned on your acceptance of and compliance with these
        Terms. These Terms apply to all visitors, users and others who access or
        use the Service. By accessing or using the Service, you agree to be
        bound by these Terms. If you disagree with any part of the terms, then
        you may not access the Service.
        <div className="subtitle">1. Accounts</div>
        When you create an account with us, you must provide us with information
        that is accurate, complete, and current at all times. Failure to do so
        constitutes a breach of the Terms, which may result in immediate
        termination of your account on our Service. You are responsible for
        safeguarding the password that you use to access the Service and for any
        activities or actions under your password, whether your password is with
        our Service or a third-party service. You agree not to disclose your
        password to any third party. You must notify us immediately upon
        becoming aware of any breach of security or unauthorized use of your
        account.
        <div className="subtitle">2. Intellectual Property</div>
        The Service and its original content, features, and functionality are
        and will remain the exclusive property of Voicify and its licensors. The
        Service is protected by copyright, trademark, and other laws of both the
        United States and foreign countries. Our trademarks and trade dress may
        not be used in connection with any product or service without the prior
        written consent of Voicify. We do not claim to own the rights to the
        personas of public figures used in the creation of our AI models.
        <div className="subtitle">3. User-Generated Content</div>
        By submitting, posting or uploading audio files or other content
        (collectively, &quot;User Content&quot;) to the Service you grant each
        user of the Service a non-exclusive license to access your User Content
        through the Service, and to use, reproduce, distribute, display and
        perform such User Content as permitted through the functionality of the
        Service and under these Terms. You represent and warrant that you have
        all rights, permissions, and consents necessary to submit the User
        Content to the Service and to grant the licenses set forth above, and
        that the use of the User Content by Voicify and its users will not
        infringe, misappropriate or violate a third party&apos;s intellectual
        property rights, rights of publicity or privacy, or any other rights or
        result in the violation of any applicable law or regulation.
        <div className="subtitle">3.1 Synthetic Vocal Models</div>
        Voicify provides synthetic voice models as part of our Service. These
        models may bear certain resemblances to the vocal characteristics of
        identifiable public figures. However, it is important to clarify that
        these models are completely artificial creations, developed through the
        application of advanced machine learning algorithms. They do not
        incorporate or utilize any proprietary recordings, performances, or
        unique voice samples of these public figures. We do not claim any
        ownership, affiliation, or representation of these public figures whose
        vocal characteristics our models may resemble. Furthermore, the creation
        and provision of these voice models do not constitute any endorsement,
        sponsorship, or partnership between Voicify and the said public figures.
        All trademarks, names, and likenesses associated with these public
        figures are their respective properties. Our voice models are provided
        solely for personal, non-commercial use and should not be used in any
        manner that suggests endorsement, sponsorship, or affiliation with the
        public figure by the user or any third party. Users of our Service are
        expressly prohibited from using the voice models to create content that
        is defamatory, unlawful, harmful, harassing, fraudulent, threatening, or
        otherwise objectionable as defined in our Prohibited Uses section. It is
        the user&apos;s responsibility to respect all applicable laws, including
        but not limited to intellectual property laws and rights of privacy and
        publicity, when using our voice models. Voicify expressly disclaims any
        liability for any use of the voice models that violates these terms or
        any applicable laws. By using our Service, you acknowledge and agree
        that Voicify is not responsible for any claims, damages, or legal
        disputes that may arise as a result of your use of the voice models. You
        further agree to indemnify and hold harmless Voicify, its officers,
        directors, employees, and agents from and against any and all claims,
        damages, liabilities, and expenses arising out of or related to your use
        of the voice models. This section does not waive or limit any other
        disclaimers or limitations of liability included in these Terms. Your
        use of our Service constitutes your agreement to this and all other
        provisions of our Terms.
        <div className="subtitle">4. Prohibited Uses</div>
        You agree not to use the Service, or any audio generated through the
        Service, for any of the following purposes:
        <ul>
          <li>
            - Engaging in any activities that are illegal or promote illegal
            activities;
          </li>
          <li>
            - Using the audio generated through the Service to create,
            distribute, or promote any content that is obscene, defamatory,
            libelous, invasive of privacy or publicity rights, abusive,
            harassing, threatening, or otherwise objectionable or harmful;
          </li>
          <li>
            - Impersonating any person or entity, or falsely stating or
            otherwise misrepresenting your affiliation with a person or entity;
          </li>
          <li>
            - Infringing, misappropriating, or violating the intellectual
            property rights, privacy rights, or any other rights of any third
            party;
          </li>
          <li>
            - Using the Service to engage in, promote, or facilitate any form of
            harassment, discrimination, or hate speech;
          </li>
          <li>
            - Using the Service for any commercial purpose, including but not
            limited to, selling or reselling the audio generated through the
            Service;
          </li>
          <li>
            - Attempting to interfere with, compromise the system integrity or
            security, or decipher any transmissions to or from the servers
            running the Service;
          </li>
          <li>
            - Uploading or transmitting viruses, worms, or any other type of
            malicious software that may damage the Service or the systems of
            other users;
          </li>
          <li>
            - Attempting to gain unauthorized access to the Service or the
            systems of other users;
          </li>
          <li>
            - Using any automated system, including but not limited to,
            &quot;robots,&quot; &quot;spiders,&quot; or &quot;offline
            readers,&quot; to access the Service;
          </li>
          <li>
            - Engaging in any activity that interferes with or disrupts the
            proper working of the Service or the enjoyment of the Service by
            other users.
          </li>
        </ul>
        <div className="subtitle">5. Termination</div>
        We may terminate or suspend your account immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if you breach the Terms. Upon termination, your right to use
        the Service will immediately cease. If you wish to terminate your
        account, you may simply discontinue using the Service.
        <div className="subtitle">6. Limitation of Liability</div>
        In no event shall Voicify, nor its directors, employees, partners,
        agents, suppliers, or affiliates, be liable for any indirect,
        incidental, special, consequential or punitive damages, including
        without limitation, loss of profits, data, use, goodwill, or other
        intangible losses, resulting from (i) your access to or use of or
        inability to access or use the Service; (ii) any conduct or content of
        any third party on the Service; (iii) any content obtained from the
        Service; and (iv) unauthorized access, use or alteration of your
        transmissions or content, whether based on warranty, contract, tort
        (including negligence) or any other legal theory, whether or not we have
        been informed of the possibility of such damage, and even if a remedy
        set forth herein is found to have failed of its essential purpose.
        <div className="subtitle">7. Disclaimer</div>
        Your use of the Service is at your sole risk. The Service is provided on
        an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis. The Service is
        provided without warranties of any kind, whether express or implied,
        including, but not limited to, implied warranties of merchantability,
        fitness for a particular purpose, non-infringement or course of
        performance. Voicify, its subsidiaries, affiliates, and its licensors do
        not warrant that a) the Service will function uninterrupted, secure or
        available at any particular time or location; b) any errors or defects
        will be corrected; c) the Service is free of viruses or other harmful
        components; or d) the results of using the Service will meet your
        requirements.
        <br />
        <br />
        <p />
        <div>
          The contents and services provided on this website are for
          entertainment and educational purposes only and are not intended to be
          taken as the genuine thoughts, opinions, or endorsements of the
          individuals to whom the AI models pertain. The AI models developed on
          our site are created using royalty-free publicly available data and do
          not in any way reflect the personal beliefs, views, or ideas of the
          real individuals. Please be aware that the use of the name, likeness,
          or persona of any individual does not constitute a personal
          endorsement or official statement from that individual. The AI models
          do not have any direct relationship or association with the
          individuals they are modelled after. We expressly disclaim any and all
          liability for any direct, indirect, incidental, consequential, or any
          other damages arising from the use or interaction with the AI models,
          including but not limited to misinterpretations, misunderstandings, or
          expectations of accuracy or authenticity.
        </div>
        <div className="subtitle">8. Governing Law</div>
        These Terms shall be governed and construed in accordance with the laws
        of England & Wales, without regard to its conflict of law provisions.
        Our failure to enforce any right or provision of these Terms will not be
        considered a waiver of those rights. If any provision of these Terms is
        held to be invalid or unenforceable by a court, the remaining provisions
        of these Terms will remain in effect. These Terms constitute the entire
        agreement between us regarding our Service, and supersede and replace
        any prior agreements we might have between us regarding the Service.
        <div className="subtitle">9. Changes</div>
        We reserve the right, at our sole discretion, to modify or replace these
        Terms at any time. If a revision is material, we will try to provide at
        least 30 days&apos; notice prior to any new terms taking effect. What
        constitutes a material change will be determined at our sole discretion.
        By continuing to access or use our Service after those revisions become
        effective, you agree to be bound by the revised terms. If you do not
        agree to the new terms, please stop using the Service.
        <div className="subtitle">10. Indemnification</div>
        You agree to defend, indemnify and hold harmless Voicify and its
        licensee and licensors, and their employees, contractors, agents,
        officers and directors, from and against any and all claims, damages,
        obligations, losses, liabilities, costs or debt, and expenses (including
        but not limited to attorney&apos;s fees), resulting from or arising out
        of a) your use and access of the Service, by you or any person using
        your account and password; b) a breach of these Terms, or c) User
        Content posted on the Service.
        <div className="subtitle">11. DMCA</div>
        It is Service&apos;s policy to respond to alleged infringement notices
        that comply with the Digital Millennium Copyright Act of 1998. If you
        believe that your copyrighted work has been copied in a way that
        constitutes copyright infringement and is accessible via the Service,
        please notify Service&apos;s copyright agent as set forth in
        Service&apos;s DMCA & Copyright Policy.
        <div className="subtitle">12. Contact Us</div>
        If you have any questions about these Terms, please contact us: By
        email: support@voicify.ai
      </div>
    </div>
  );
};

export default TermsPage;
